// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

// #region Imports

import useDataTestId from "../../hooks/values/useDataTestId";

// #endregion

/**
 * Composant permettant de récupérer le data-testid fusionné avec les préfixes potentiellement
 * renseigné plus haut dans l'arbre React
 */
var Accessor = function Accessor(_ref) {
  var dataTestId = _ref.dataTestId,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? '-' : _ref$separator,
    children = _ref.children;
  var completeDataTestId = useDataTestId(dataTestId, separator);
  return children(completeDataTestId);
};
export default Accessor;